import { Novel } from "./Novel"
import { getMypageNovelNovelId } from "../../../api/v1/mypage/novel/[novel_id]/get"
import { MypageNovelNovelIdGetInputModel } from "../../../api/v1/mypage/novel/[novel_id]/GetInputModel"
import { adaptNovel } from "./adaptNovel"

// ログインユーザー向け小説を取得
export const fetchNovelForUser = (novelId: number): Promise<Novel> => {
  return getMypageNovelNovelId(
    new MypageNovelNovelIdGetInputModel(novelId),
  ).then(adaptNovel)
}
